export default {
  b72605e67be5675a66a9fe055ca8ec75:
    'You haven\'t signed the "Learn now, pay Later" order yet. Please contact your instructor for more details',
  b835123381a57437a941eb5957bec2bf: 'Invalid link. Please contact the instructor!',
  '816d600f5c1edc267c113181dbba5065': '"Pay immediately',
  '58f266efc455155695cd9faa0c8f6d2a': 'Processing...',
  '910862f781d8bbd3adeb288fdf3a7e2b': 'Product details',
  fc0dceaafe5baf4048d3f27a0e324bf7: 'Order summary',
  c0715b25b73053f961dc52a8e3bff6d7: 'Payment method',
  '55b74ed23a133ef0dfe7af717d5ad599': 'Are you sure you want to give up paying?'
};
